import { render, staticRenderFns } from "./empty.vue?vue&type=template&id=b80e754e&scoped=true"
var script = {}
import style0 from "./empty.vue?vue&type=style&index=0&id=b80e754e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80e754e",
  null
  
)

export default component.exports